export default __webpack_public_path__ + "static/media/grid-icon-view-doc.0f3e67bc.svg";